import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { useTranslation } from '@lt/localization';
import { SearcherEmpty } from '@lt/components';

import { SEARCH_TYPE_NAMES } from 'src/constants/search';
import type { SearchType } from 'src/types/search';

import { searchTypeSelector } from 'src/store/view/selectors';
import { getLinkedDepartures } from '../../../../domain/state/linked/selectors';

import type { IDeparture } from './DepartureList';
import { DepartureList } from './DepartureList';

const mapStateToProps = (state) => ({
  linkedDepartures: getLinkedDepartures(state),
  searchType: searchTypeSelector(state),
});

interface Props {
  linkedDepartures: IDeparture[] | null;
  isMobile?: boolean;
  searchType: SearchType;
}

export const EmptyHotels = connect<Props, TPseudoObject, TPseudoObject>(
  mapStateToProps,
)(({ linkedDepartures, isMobile = false, searchType }: Props) => {
  const { t } = useTranslation();

  return (
    <StyledContainer $isMobile={isMobile}>
      <SearcherEmpty
        label={t('explore.hotels.empty.label', {
          context: searchType,
        })}
        hint={t('explore.hotels.empty.hint', { context: searchType })}
        isHotelOnly={searchType === SEARCH_TYPE_NAMES.HOTEL}
      />
      {Array.isArray(linkedDepartures) && linkedDepartures.length > 0 ? (
        <LinkedDepartures
          linkedDepartures={linkedDepartures}
          isMobile={isMobile}
        />
      ) : null}
    </StyledContainer>
  );
});

interface LinkedDeparturesProps {
  linkedDepartures: IDeparture[];
  isMobile: boolean;
}

const LinkedDepartures = ({
  linkedDepartures,
  isMobile,
}: LinkedDeparturesProps) => {
  const { length } = linkedDepartures;

  // Делим на два столбца
  const halfLength = length % 2 === 0 ? length / 2 : length / 2 + 1;
  const deps1 = linkedDepartures?.slice(0, halfLength);
  const deps2 = linkedDepartures?.slice(halfLength, length);

  return (
    <StyledWrapper $isMobile={isMobile}>
      <DepartureList departureList={deps1} />
      <DepartureList departureList={deps2} />
    </StyledWrapper>
  );
};

const StyledContainer = styled.div<{ $isMobile: boolean }>`
  width: 100%;

  ${({ $isMobile }) => ($isMobile ? `margin-left: 0; margin-top: 24px;` : '')}
`;

const StyledWrapper = styled.div<{ $isMobile: boolean }>`
  border-radius: 4px;
  margin-top: 24px;
  background-color: #fff;
  display: flex;
  padding: 16px;
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
  justify-content: center;
`;
